import { useMemo } from "react";

import type { AccessibleItem } from "app/components/React/QuickSearch/pageData/filterAccessibleItems";
import { filterAccessibleItems } from "app/components/React/QuickSearch/pageData/filterAccessibleItems";
import { getSidebarAccessMap } from "app/components/React/QuickSearch/pageData/getSidebarAccessMap";

export const useAccessibleItems = <T>(
    items: readonly T[],
    getUiRouterState: (item: T) => string | undefined,
): AccessibleItem<T>[] =>
    useMemo(() => filterAccessibleItems(items, getSidebarAccessMap(), getUiRouterState), [items, getUiRouterState]);
